module.exports = "{{title}}"


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/app/toolbox/typing/typing.component.html
// module id = ../../../../../src/app/toolbox/typing/typing.component.html
// module chunks = main